export enum EventAction {
  CLICK = 'click',
  CHANGE = 'change',
  SUBMIT = 'submit',
}
